import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import { CardSection } from 'components/Shared/Cards';
import { SCAFFOLDING } from 'theme';

export const PreviewRow = styled(CardSection)`
    display: flex;
    align-items: center;

    > * + * {
        margin-left: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    }
`;

export const PreviewImage = styled.span`
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: ${SCAFFOLDING.COLUMN_WIDTH(5)};
    background: #eee url(${(props) => props.img}) center no-repeat;
    background-size: cover;
`;

export const PreviewDesc = styled.span`
    flex: 1 1 auto;
    display: block;

    ${ifProp(
        'hasPreview',
        css`
            width: ${SCAFFOLDING.COLUMN_WIDTH(7)};
            min-width: 25%;
            margin-left: ${SCAFFOLDING.COLUMN_WIDTH(5)};
            padding-left: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
            overflow-wrap: break-word;
            word-wrap: break-word;
            hyphens: auto;

            > * {
                display: block;
            }
        `,
        css`
            font-weight: 700;
        `
    )}
`;
